<div fxLayout="row" class="background">
  <div fxFlex="75" fxFlexOffset="12%">
    <section id="header">
      <h1 class="h1Header">PEDIDOS ASIGNADOS A CADETE</h1>
    </section>

    <div fxLayout="row" class="tablaCom">
      <div fxFlex=120 fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">
          <table mat-table [dataSource]="dataSource" class="tabla">

            <!-- Codigo Column -->
            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef class="table-header"> Código </th>
              <td mat-cell *matCellDef="let element" class="table-content">{{element.codigo}}</td>
            </ng-container>

            <!-- Store Column  -->
            <ng-container matColumnDef="tienda">
              <th mat-header-cell *matHeaderCellDef class="table-header">Tienda </th>
              <td mat-cell *matCellDef="let element" class="table-content"> {{element.tienda}}</td>
            </ng-container>

            <!-- Status Column  -->
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef class="table-header">Estado </th>
              <td mat-cell *matCellDef="let element" class="table-content">
                <div>{{element.estado}}</div>
                <mat-icon>stop_circle</mat-icon>
              </td>
            </ng-container>

            <!-- User Column  -->
            <ng-container matColumnDef="usuario">
              <th mat-header-cell *matHeaderCellDef class="table-header">Usuario</th>
              <td mat-cell *matCellDef="let element" class="table-content"> {{element.usuario}}<br> {{element.telefono}}</td>
            </ng-container>

            <!-- Address Column  -->
            <ng-container matColumnDef="direccion">
              <th mat-header-cell *matHeaderCellDef class="table-header">Dirección</th>
              <td mat-cell *matCellDef="let element" class="table-content"> {{element.direccion}} </td>
            </ng-container>

            <!-- Items Column  -->
            <ng-container matColumnDef="items">
              <th mat-header-cell *matHeaderCellDef class="table-header">Items</th>
              <td mat-cell *matCellDef="let element" class="table-content">
                <button mat-button (click)="open()">Ver</button>
              </td>
            </ng-container>

            <!-- total Column  -->
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef class="table-header">Total</th>
              <td mat-cell *matCellDef="let element" class="table-content">{{element.total}}</td>
            </ng-container>

            <!-- Options Column  -->

            <ng-container matColumnDef="opciones">
              <th mat-header-cell *matHeaderCellDef class="table-header">Opciones</th>
              <td mat-cell *matCellDef="let element" class="table-content">
                <button mat-button [matMenuTriggerFor]="belowMenu">Opciones</button>
                <mat-menu #belowMenu="matMenu" yPosition="below">
                  <button mat-menu-item>Confirmar Viaje</button>
                  <button mat-menu-item>Anular Orden</button>
                  <button mat-menu-item (click)="printOrder()">Imprimir Ticket</button>
                </mat-menu>
                <div class="detail">{{element.nombreCadete}}{{element.idCadete}} - {{element.fechaPedido}}</div>
              </td>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </table>
        </mat-card>
      </div>
    </div>
  </div>
</div>
